import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

const supportsMatchMedia = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function';

/** True when the visitor asked the OS to reduce motion. */
export default function usePrefersReducedMotion() {
  const [reduced, setReduced] = useState(
    () => supportsMatchMedia() && window.matchMedia(QUERY).matches
  );

  useEffect(() => {
    if (!supportsMatchMedia()) return undefined;

    const mql = window.matchMedia(QUERY);
    const onChange = (event) => setReduced(event.matches);

    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return reduced;
}
